import React from 'react';
import ProfilePage from './ProfilePage';

const ResponsiveProfilePage: React.FC = () => {
  // Use a single responsive profile component for all devices
  return <ProfilePage />;
};

export default ResponsiveProfilePage;
